var request = new XMLHttpRequest();

request.onreadystatechange = function() {
  if(request.readyState === 4) {

    if(request.status === 200) {

      var modal_spinner = document.querySelector('.modal-spinner');
      if(modal_spinner) {
        modal_spinner.parentNode.removeChild(modal_spinner);
        //modal_spinner.remove();
      }

      var responseHTML = document.createElement('div');
      responseHTML.innerHTML = request.responseText;
      var element = responseHTML.querySelector('.hentry').outerHTML;

      var modal_content = document.querySelector('.modal-content');
      if(modal_content) {
        modal_content.innerHTML = element;
      }

    } else {
      console.log('An error occurred during your request: ' +  request.status + ' ' + request.statusText);
    }
  }
}

var els = document.querySelectorAll('.modal-open');
for(i = 0; i < els.length; i++) {
  els[i].addEventListener('click', function(e) {
    e.preventDefault();
    // var currentState = history.state;
    // window.history.pushState( currentState, '', this.getAttribute('href') );
    // var body = document.getElementsByTagName('body')[0];

    // create modal
    var modal = document.createElement('div');
    modal.setAttribute('id', 'modal');

    // create close button, append it to modal
    var close_modal_button = document.createElement('a');
    close_modal_button.classList.add('modal-close');
    close_modal_button.innerHTML = 'Sulje';
    // close_modal_button.setAttribute('href', '#');
    modal.appendChild( close_modal_button );

    // Add event listener for close button
    close_modal_button.addEventListener('click', function(e) {
      e.preventDefault();
      if( modal.classList.contains('open') ) {
        // Hide modal
        modal.classList.remove('open');
        document.body.classList.remove('modal-open');

        // Remove modal
        //modal.remove();
        modal.parentNode.removeChild(modal);
      }
    });

    // Add content container
    var modal_content = document.createElement('div');
    modal_content.classList.add('modal-content');

    // Add loading spinner
    var modal_loading = document.createElement('div');
    modal_loading.classList.add('modal-spinner');
    modal_content.appendChild( modal_loading );

    modal.appendChild( modal_content );

    console.log('append element to body');
    document.body.appendChild( modal );

    console.log('add class open to modal element: show be visible');
    modal.classList.add('open');

    document.body.classList.add('modal-open');

    request.open('get', this.getAttribute('href'));
    request.send();
  })
}

// var el = document.querySelector('.modal-close');
// var els = document.querySelectorAll('.modal-close');
// for(i = 0; i < els.length; i++) {
//   els[i].addEventListener('click', function(e) {
//     e.preventDefault();
//     console.log('clicked close modal');
//     var modal = document.querySelector('.modal');
//     if( modal.classList.contains('open') ) {
//       // modal.remove();
//       // modal.classList.remove('open');
//       console.log('removing open class from modal');
//     }
//   })
// }
// document.onkeydown = function(evt) {
//   evt = evt || window.event;
//   var isEscape = false;
//   if ("key" in evt) {
//     isEscape = (evt.key == "Escape" || evt.key == "Esc");
//   } else {
//     isEscape = (evt.keyCode == 27);
//   }
//   if (isEscape) {
//     console.log('user pressed esc');
//     var modal = document.querySelector('.modal');
//     modal.classList.remove('open');
//     console.log('removing open class from modal');

//     var isEscape = false;
//   }
// };


/*

$(document).on('click', '.overlay-open', function(e) {
  e.preventDefault();
  $('.overlay-content').empty();

  var $href = $(this).attr('href');

  $.ajax({
    url: $href  + '?ajax=1',
    dataType: 'html',
    success: function(data) {
      $('.overlay-content').html(data);

      window.history.replaceState({}, "", $href);

      if( !$('.overlay').hasClass('shown') ) {
        $('.overlay').addClass('shown');
        $('body').addClass('no-scroll');
      }

      $('.overlay').scrollTop(0);
      $('.post-nav').tooltip();
    },
    error: function() {
      console.log("An error occured while loading article. Redirecting browser in 3 seconds.");

      setTimeout(function () {
        window.location.href = $href;
      }, 3000);
    }
  }).done(function() {
    $('.overlay-content').fadeIn(500);
  });
});

$(document).on('click', '.overlay-close', function(e) {
  e.preventDefault();

  $('.overlay').removeClass('shown');
  $('body').removeClass('no-scroll');
  $('.overlay-content').empty();
  window.history.replaceState({}, "", $(this).attr('href'));
});

*/
